import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

const mapState = (state) => {
	return {
		initialValues: {
			apaterno: state.registroAF.apaterno,
			amaterno: state.registroAF.amaterno,
			nombres: state.registroAF.nombres,
			email: state.registroAF.email,
			fecha_nacimiento: state.registroAF.fechaNacimiento,
			fecha_nacimiento_date: state.registroAF.fechaNacimientoDate,
			genero: state.registroAF.genero,
			rfc: state.registroAF.rfc,
			poliza: state.registroAF.poliza,
			lada_movil: state.registroAF.ladaCelular,
			telefono_movil: state.registroAF.telCelular
		}
	};
};

const telefono = tipo => (value, campos) => {
	let numero = (value != undefined)? value.replace("+","").replace(" ","") : "";
	let prefijo = (/lada/g.test(tipo)) ? "+" : "";
	campos[tipo] = (numero == "" || isNaN(numero))? "" : prefijo + numero;
};

const validate = (campos) => {
	const errors = {};

	if (!campos.email) {
		errors.email = "Campo requerido.";
	} else {
		campos.email =  campos.email.replace(" ","");
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(campos.email)) {
			errors.email = "Formato de correo inválido. Intenta nuevamente.";
		}
	}

	if (!campos.nombres) {
		errors.nombres = "Campo requerido.";
	}

	if (!campos.apaterno) {
		errors.apaterno = "Campo requerido.";
	}
	
	if (!campos.amaterno) {
		errors.amaterno = "Campo requerido.";
	}

	if(!campos.telefono_movil) {
		errors.telefono_movil = "Campo requerido.";
	} else if (!campos.lada_movil && campos.telefono_movil) {
		errors.telefono_movil = "Campo Lada requerido.";
	} else if (campos.lada_movil && campos.telefono_movil && ((campos.lada_movil.length + campos.telefono_movil.length) -1) != 10) {
		errors.telefono_movil = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}

	if (!campos.fecha_nacimiento || campos.fecha_nacimiento == " ") {
		errors.fecha_nacimiento = "Campo requerido.";
	}
	
	if(campos.rfc){
		if(!/^([a-zA-ZñÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([a-zA-Z\d]{2})([A\d])$/.test(campos.rfc)) {
			errors.rfc = "Formato de RFC inválido.";
		}
	}

	return errors;
};

const renderField = ({ input, label, type, max, disabled, meta: { touched, error, warning } }) => {
	return (
		<div>
			<input {...input} type={type} maxLength={max} disabled={disabled} />
			{touched && (error &&
				<div className="error-wrap">
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

const renderFieldDate =  ({ input, type, onChange, meta: { touched, error, warning } }) => {
	return (
		<div>
			<input {...input} type={type} onChange={onChange} className="datepicker-input" />
			{touched && (error &&
				<div className="error-wrap">
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

class Datos extends React.Component {

	handleDateChangeEvent = (ev) => {
		this.props.change("fecha_nacimiento", ev.format());
		this.props.change("fecha_nacimiento_date", ev.date.getTime());
	}

	componentWillMount = () => {
		var _this = this;
		$(function () {
			$("input.datepicker-input").datepicker({
				format: "dd   -   MM   -   yyyy",
				language: "es",
				startDate: "-120y",
				endDate: "-16y",
				autoclose: true,
				disableTouchKeyboard: true
			}).on("changeDate", _this.handleDateChangeEvent);
		});
	}

	render () {
		const { handleSubmit, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="text-content mt-34">
					<div className="datos-wrap row">
						<div className="col-xs-12 row">
							<div className="col-md-6 col-xs-12">
								<h5><i><img src={ require("../img/icon_user.png") } alt="" /></i>Datos Personales</h5>
								<div className="row mt-25">
									<div className="col-xs-12">
										<div className="input-wrap">
											<label>Apellido Paterno</label>
											<span className="clearfix input-active">
												<Field name="apaterno" label="Apellido Paterno" component={renderField} type="input"/>
											</span>
										</div>
									</div>
									<div className="col-xs-12">
										<div className="input-wrap">
											<label>Apellido Materno</label>
											<span className="clearfix input-active">
												<Field name="amaterno" label="Apellido Materno" component={renderField} type="input"/>
											</span>
										</div>
									</div>
									<div className="col-xs-12">
										<div className="input-wrap">
											<label>Nombre(s)</label>
											<span className="clearfix input-active">
												<Field name="nombres" label="Nombre(s)" component={renderField} type="input"/>
											</span>
										</div>
									</div>
								</div>
							</div>

							<div className="col-md-6 col-xs-12">
								<h5><i><img src={ require("../img/icon-ocupacion.svg") } alt="" /></i>Datos de contacto</h5>
								<div className="row mt-25">
									<div className="col-xs-12">
										<div className="input-wrap">
											<label>Correo electrónico</label>
											<span className="input-active">
												<Field name="email" component={renderField} type="text" disabled="disabled" />
											</span>
										</div>
									</div>
									<div className="col-xs-12">
										<div className="input-wrap">
											<label>Fecha de nacimiento</label>
											<span className="clearfix input-active">
												<Field name="fecha_nacimiento" type="text" component={renderFieldDate} />
											</span>
										</div>
									</div>
									{/*<div className="col-xs-12" style={{"paddingBottom":"25px"}}>
										<div className="input-wrap">
											<label style={{"display":"block", "marginBottom":"15px"}}>Género</label>
											<div className="checkbox-green" style={{"width":"50%","float":"left"}}>
												<Field name="genero" component="input" type="radio" value="masculino" />
												<label></label>
												<span style={{"border":"0px"}}>Masculino</span>
											</div>
											<div className="checkbox-green" style={{"width":"50%","float":"left","margin":"0px"}}>
												<Field name="genero" component="input" type="radio" value="femenino" />
												<label></label>
												<span style={{"border":"0px"}}>Femenino</span>
											</div>
										</div>
									</div>*/}
								</div>
							</div>
						</div>
						
						<div className="col-md-6 col-xs-12 row">
							<div className="col-md-12 col-xs-12">
								<h5>
									<i><img src={require("../img/icon_cellphone.png")} alt="" /></i>Teléfono celular
									<span className="orange-tooltip">
										<button type="button" className="btn btn-primary btn-lg" data-toggle="modal" data-target="#modal-celular" >?</button>
									</span>
								</h5>
								<div className="row mt-25">
									<div className="col-xs-12">
										<div className="row">
											<div className="col-xs-4">
												<div className="input-wrap">
													<label>Lada</label>
													<span className="clearfix input-active">
														<Field name="lada_movil" component={renderField} type="text" max="4" validate={telefono("lada_movil")} />
													</span>
												</div>
											</div>
											<div className="col-xs-8">
												<div className="input-wrap">
													<label>Teléfono</label>
													<span className="clearfix input-active">
														<Field name="telefono_movil" component={renderField} type="text" max="8" validate={telefono("telefono_movil")} />
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div className="col-xs-12 row">
							<div className="col-md-12 col-xs-12">
								<h5>
									<i><img src={ require("../img/icon-document.svg") } alt="" /></i>Datos Opcionales
									<span className="orange-tooltip">
										<button type="button" className="btn btn-primary btn-lg" data-toggle="modal" data-target="#modal-rfc" >?</button>
									</span>
								</h5>
								<div className="row mt-25">
									<div className="col-md-6 col-xs-12">
										<div className="input-wrap">
											<label>RFC (homoclave)</label>
											<span className="clearfix">
												<Field name="rfc" type="text" component={renderField} />
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>						
					</div>
					<button className="orange-rectangle" type="submit" disabled={submitting}>Siguiente</button>
				</div>
				
				<Field name="poliza" component="input" type="hidden" />
				<Field name="fecha_nacimiento_date" component="input" type="hidden" />
				<Field name="genero" component="input" type="hidden" />
				
				<div className="modal fade" id="modal-celular" tabIndex="-1" role="dialog" aria-labelledby="modal-celularLabel">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title orange-text" id="modal-celularLabel">Nota</h4>
							</div>
							<div className="modal-body">
								<p>Es importante que nos lo proporciones ya que a este número te contactaremos en caso de que olvides tu contraseña o requieras asistencia.</p>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn orange-btn" data-dismiss="modal">Aceptar</button>
							</div>
						</div>
					</div>
				</div>
				<div className="modal fade" id="modal-rfc" tabIndex="-1" role="dialog" aria-labelledby="rfc-celularLabel">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title orange-text" id="rfc-celularLabel">Nota</h4>
							</div>
							<div className="modal-body">
								<p>Es importante que nos lo proporciones tu RFC con homoclave, eso nos ayudara en agilizar tus tramitres.</p>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn orange-btn" data-dismiss="modal">Aceptar</button>
							</div>
						</div>
					</div>
				</div>				
			</form>
		);
	}
}

Datos = reduxForm({form: "registro-datos", validate})(Datos);

export default connect(mapState, null)(Datos);



// WEBPACK FOOTER //
// ./src/registro-familiar/datos.frm.js